<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <saa-s-child-page-container>
    <template #title>
      <div class="text-h3">
        {{ stepHint }}
      </div>
      <div class="text-body-2 mt-2">
        {{ $t('DontCloseOrRefreshWindowDuringActivation') }}
      </div>
    </template>

    <v-progress-circular
      class="mt-8 mx-16"
      indeterminate
      size="48"
    />
  </saa-s-child-page-container>
</template>

<script>

import SaaSChildPageContainer from '@/views/SaaS/widget/SaaSChildPageContainer.vue'
import { getUserCurrentStoreInfo } from '@/model/dataLayer/api/SaaS/user'
import { sleep } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import { enterStore } from '@/model/dataLayer/api/SaaS/storeService'

export default {
  name: 'OwnChoiceBaseLicense',
  components: { SaaSChildPageContainer },
  props: {},
  data: function () {
    return {
      stepHint: this.$t('PaymentShopBeingCreated')
    }
  },
  watch: {},
  async mounted () {
    while (true) {
      const mainStoreDevice = (await getUserCurrentStoreInfo())
      await sleep(500)
      if (!mainStoreDevice.notReady) {
        await enterStore(mainStoreDevice.currentStoreId)
        break
      }
    }

    await this.$router.push('/input-restaurant-info')
  },
  methods: {}
}
</script>

<style scoped>

</style>
